module.exports = __webpack_public_path__ + "files/abb5f09f3e3ecba97425657769c8e621.png";